<fs-dialog>
  <div mat-dialog-title>Switch organization</div>
  <mat-dialog-content>

    @if (account) {
      <fs-list [config]="listConfig">
        <fs-list-column>
          <ng-template fs-list-cell let-environment="row">
            <div class="environment-item">
              <div class="fs-row.gap-sm">
                @if (environment.image.small) {
                  <fs-badge
                    shape="circle"
                    [size]="30"
                    [image]="environment.image.small">
                  </fs-badge>
                }
                <div>
                  {{ environment.name }}
                </div>
              </div>
            </div>
          </ng-template>
        </fs-list-column>
      </fs-list>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="null" type="button">Done</button>
  </mat-dialog-actions>
</fs-dialog>
